// src/api/client.js
import axios from 'axios';

const baseURL = String(import.meta.env.VITE_API_URL || '')
  .trim()
  .replace(/\/+$/, ''); // remove barra final

const api = axios.create({
  baseURL,           // ex.: https://api.canar.in
  timeout: 5000
});

export async function getCanarinPublic(username) {
  const { data } = await api.get(`/v1/canarin/${encodeURIComponent(username)}`);
  return data;
}

export default api;
